import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8v8","key":"svg-0"}],["path",{"d":"M14 8l-2.5 4l2.5 4","key":"svg-1"}],["path",{"d":"M10 12h1.5","key":"svg-2"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-3"}]]

const IconSquareRoundedLetterK = createReactComponent('outline', 'square-rounded-letter-k', 'SquareRoundedLetterK', __iconNode);

export default IconSquareRoundedLetterK;